import { TriangleAlert } from 'lucide-react';
import NoItems from '@/components/ui/NoItems.tsx';

interface LoadErrorProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Czego nie udało się wczytać, w dopełniaczu — „rachunku uczestnika”. */
  subject: string;
}

/**
 * Nieudane zapytanie. Osobny stan od pustki, bo „nie wiemy” to co innego niż
 * „nic tu nie ma” — na jedno użytkownik odświeża, na drugie wychodzi.
 */
const LoadError = ({ subject, ...props }: LoadErrorProps) => (
  <NoItems
    icon={<TriangleAlert />}
    title="Nie udało się wczytać danych"
    description={`Nie udało się wczytać ${subject}. Odśwież stronę i spróbuj ponownie.`}
    {...props}
  />
);

export default LoadError;
